import { Injectable, inject } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable, filter, tap } from "rxjs";

import { CountrySelectorData } from "@hermes/api-model-country";
import { BannersData, FooterData, SupportInfos } from "@hermes/api-model-shell";

import { Locale } from "@hermes/locale";
import { ShellAppearanceType } from "@hermes/utils-generic-constants";

import {
    fetchBanners,
    fetchBannersFailure,
    fetchBannersSuccess,
    fetchCountrySelectorData,
    fetchFooterItems,
    fetchFooterItemsFailure,
    fetchFooterItemsSuccess,
    fetchSupportInfos,
    fetchSupportInfosFailure,
    fetchSupportInfosSuccess,
    setShell,
    updateBasket,
} from "../actions/shell.actions";
import {
    selectActivatedLocales,
    selectBanners,
    selectBasket,
    selectBasketTotalItems,
    selectCountrySelectorData,
    selectFooterItems,
    selectshell,
    selectSupportInfos,
} from "../selectors/shell.selectors";
import { ShellState } from "../state/shell.state";

@Injectable()
export class ShellFacade {
    private store = inject<Store<ShellState>>(Store);

    public shell$: Observable<ShellAppearanceType> =
        this.store.select(selectshell);
    /**
     * Selectors
     */
    public basket$ = this.store.select(selectBasket);

    public basketTotalItems$ = this.store.select(selectBasketTotalItems);

    public banners$ = this.store.select(selectBanners);

    public footerItems$ = this.store.select(selectFooterItems);

    public supportInfos$ = this.store.select(selectSupportInfos);

    /**
     * Actions
     */

    public getBanners(): Observable<BannersData> {
        return this.banners$.pipe(filter(Boolean));
    }

    public getCountrySelectorData(): Observable<CountrySelectorData> {
        return this.store.select(selectCountrySelectorData).pipe(
            tap((countrySelectorData) => {
                if (!countrySelectorData) {
                    this.store.dispatch(fetchCountrySelectorData());
                }
            }),
            filter(Boolean),
        );
    }

    public getActivatedLocales(): Observable<Locale[]> {
        return this.store.select(selectActivatedLocales).pipe(
            tap((activatedLocales) => {
                if (!activatedLocales) {
                    this.store.dispatch(fetchCountrySelectorData());
                }
            }),
            filter(Boolean),
        );
    }

    public setShell(shell: ShellAppearanceType): void {
        this.store.dispatch(setShell({ shell }));
    }

    public updateBasket(amount: number): void {
        this.store.dispatch(updateBasket({ amount }));
    }

    public fetchBanners(): void {
        this.store.dispatch(fetchBanners());
    }

    public fetchBannersSuccess(data: BannersData): void {
        this.store.dispatch(fetchBannersSuccess({ data }));
    }

    public fetchBannersFailure(error: Error): void {
        this.store.dispatch(fetchBannersFailure({ error }));
    }

    public fetchFooterItems(): void {
        this.store.dispatch(fetchFooterItems());
    }

    public fetchFooterItemsSuccess(data: FooterData): void {
        this.store.dispatch(fetchFooterItemsSuccess({ data }));
    }

    public fetchFooterItemsFailure(error: Error): void {
        this.store.dispatch(fetchFooterItemsFailure({ error }));
    }

    public fetchSupportInfos(): void {
        this.store.dispatch(fetchSupportInfos());
    }

    public fetchSupportInfosSuccess(data: SupportInfos): void {
        this.store.dispatch(
            fetchSupportInfosSuccess({
                customerServiceDetail: data.customerServiceDetail,
                footer: data.footer,
            }),
        );
    }

    public fetchSupportInfosFailure(error: Error): void {
        this.store.dispatch(fetchSupportInfosFailure({ error }));
    }
}
